import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const run = async () => {
      const hash = window.location.hash;
      const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
      if (!sid) { navigate("/login"); return; }
      try {
        const { data } = await api.post("/auth/session", { session_id: sid });
        setUser(data.user);
        window.history.replaceState({}, "", "/library");
        navigate("/library");
      } catch {
        navigate("/login");
      }
    };
    run();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0B0E]">
      <p className="text-[#8A8F98] font-serif text-2xl tracking-wide">Entering the archive…</p>
    </div>
  );
}
